import React from "react"
import { graphql } from "gatsby"

import Author from "components/author"

const AuthorPage = (props) => {
  const {
    data: {
      author,
      allAirtableCollective: { nodes: collectiveData },
      allClass: { nodes: classesNodes },
    },
  } = props

  const collectiveMemberData = collectiveData[0]?.data
  const { articles } = author
  let authorArticles = []
  let authorClasses = []

  const actualDate = new Date().toISOString()
  authorArticles = articles
    .sort((a, b) => new Date(b.publishDate) - new Date(a.publishDate))
    .map((postItem) => ({
      ...postItem,
      previewImage: JSON.parse(postItem.previewImage),
    }))
    .filter((item) => item.publishDate < actualDate)
  const earliestArticle = authorArticles[authorArticles.length - 1]

  authorClasses = classesNodes.filter(
    (classItem) => classItem.active && classItem.availableForPurchase,
  )

  return (
    <Author
      firstArticleDate={earliestArticle?.publishDate}
      author={author}
      authorArticles={authorArticles}
      authorClasses={authorClasses}
      collectiveMemberData={collectiveMemberData}
    />
  )
}

export default AuthorPage

export const query = graphql`
  query ($url: String) {
    author(url: { eq: $url }) {
      id
      userId
      indexForSearch
      url
      name
      title
      biography
      interview
      image
      twitter
      pinterest
      instagram
      facebookPage
      website
      articles {
        ... on Article {
          id
          url
          authors {
            url
          }
          previewImage
          publishDate
          subcategory
          titles {
            body
            site
          }
        }
      }
    }
    allAirtableCollective(filter: { data: { user: { url: { eq: $url } } } }) {
      nodes {
        id
        data {
          image
        }
      }
    }
    allClass(filter: { instructors: { elemMatch: { url: { eq: $url } } } }) {
      nodes {
        ... on Class {
          classId
          id
          url
          title
          active
          image
          availableForPurchase
          instructorByline
          instructors {
            id
            url
          }
        }
      }
    }
  }
`
